import FileCopy from '@mui/icons-material/FileCopy';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FileCopyIcon(props: FixMe) {
  return <FileCopy {...props} />;
}

export default FileCopyIcon;
